import React, { Component, Fragment } from 'react';

import store from '../store/store.js'

import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import RaisedButton from 'material-ui/RaisedButton';

const AutoTurs = (props) => {
  var subheader = '';

  const turs = store.turs.filter( (item)=>{ return ( item.type === "Автобусный" ) })

  const listrow = (row, index) => {
    var Sub = null;
    if (subheader !== row.turgroup) {
      subheader = row.turgroup; 
      Sub = (<TableRow >
              <TableRowColumn style={{width: "40%"}}>
                <h2>{subheader}</h2>
                <p> Отели: <b>{store.getHotelGroupsForTur(row.id).join(', ')}</b> </p>
              </TableRowColumn>
              <TableRowColumn></TableRowColumn>
              <TableRowColumn></TableRowColumn>
              <TableRowColumn></TableRowColumn>
              <TableRowColumn></TableRowColumn>
             </TableRow>) 
      } 

    return (  <Fragment key={row.id}>
                {Sub}
              <TableRow >
                <TableRowColumn style={{width: "40%"}}> {row.name} </TableRowColumn>
                <TableRowColumn> {row.begtur} </TableRowColumn>
                <TableRowColumn > {row.kol} </TableRowColumn>
                <TableRowColumn> 
                  <RaisedButton label="План мест"
                    onClick={()=>{ store.showLightBox(`${store.host}/plan_mest.jpg?id=${row.id}`) } }
                    />
                </TableRowColumn>
                <TableRowColumn>
                  <RaisedButton primary={true} label="Выбрать" 
                    onClick={()=>{ store.setTur(row); props.click(); } }
                    disabled={row.kol !== '0' ? false : true }
                    />
                </TableRowColumn>
              
              </TableRow>
              </Fragment>);
  }
    
    return (
    <Table selectable={false}>
      <TableHeader adjustForCheckbox={false} displaySelectAll={false}>
        <TableRow>
          <TableHeaderColumn style={{width: "40%"}}>Название тура</TableHeaderColumn>
          <TableHeaderColumn>Дата начала</TableHeaderColumn>
          <TableHeaderColumn >Количество мест</TableHeaderColumn>
          <TableHeaderColumn ></TableHeaderColumn>
          <TableHeaderColumn ></TableHeaderColumn>
        </TableRow>
      </TableHeader>
      <TableBody 
        displayRowCheckbox={false}
        >
      {turs.map(listrow)}

      </TableBody>
      
    </Table>

    )
}


export default AutoTurs;




// WEBPACK FOOTER //
// ./src/coms/AutoTurs.jsx